import { render } from "./SupplierIntegrations.vue?vue&type=template&id=93bcadc8&scoped=true"
import script from "./SupplierIntegrations.vue?vue&type=script&lang=js"
export * from "./SupplierIntegrations.vue?vue&type=script&lang=js"

import "./SupplierIntegrations.vue?vue&type=style&index=0&id=93bcadc8&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-93bcadc8"]])

export default __exports__